import React from 'react';

const AboutMe = () => {
    const [state] = React.useState({subHeading:'About Me', text:'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Recusandae, eum? Non fuga laboriosam explicabo ut'});
    const [header] = React.useState([{
        id:1,
        title:'Name:', text:'Saami U Karim'
    },
    {
        id:2,
        title:'Email:', text:'saamiukarim1@gmail.com'
    },
    {
        id:3,
        title:'Phone:', text:'+88 01847 438331'
    },
    {
        id:4,
        title:'Linked In:', text:'https://www.linkedin.com/in/saami-u-karim-66a436215/'
    },
])
    return (
        <div className="about pt-5 mt-5">
           
            <div className="containerr ">
            <div data-aos="zoom-in" className="common bg-about">
                    <h1 className="main-header">
                    {state.subHeading}    
                    </h1>
                    
                    <div className="common-border"></div>
                    </div>

             
                    <div className="roww h-650 about-row">
                        <div className="coll-6">
                            <div data-aos="fade-right" className="about-img">
                            <img src="https://i.ibb.co/bvbc59Z/Pics-Art-06-22-12-40-13.png" />
                            </div>

                        </div>
                        <div className="coll-6">
                            <div data-aos="zoom-left"className="about-info">
                                <h1>Hi There!</h1>
                                <div className="about-info-p1">
                                I am a quick learner. I believe in hard work and efficiency. I always like to learn new things and have experience with new stuff. Dedicated, energetic, and motivated team player seeking a career that would enable me to utilize into the Web developing field.


                                </div>
                                
                                <div className="info-contacts">
                                    <div className="roww">
                                        {
                                            header.map(info => (
                                                <div className="coll-6">
                                                <strong>{info.title}</strong>
                                                <p>{info.text}</p>
                                            </div>

                                            ))
                                        }
                                      
                                       
                                    </div>
                                    
                                </div>
                            </div>

                        </div>
                    </div>
                    
            </div>
            
        </div>
    );
};

export default AboutMe;